import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import NumberInput from '../../shared/NumberInput/number.input.vue';
import { CallNative } from '../../../services/EpicContextService/call.native';
@Component({
    components: {
        NumberInput
    }
})
export default class ListingPresentationMobileBasic extends Vue {
    public data: string = '';
    public isLoading: boolean = false;
    public activityId: any = '';
    public entrustId: any = '';
    public formData = {
        type: 'Detached',
        address: ''
    };
    public clientData = {
        name: '',
        email: ''
    };
    public roomData = {
        bedroom: 3,
        washroom: 2,
        garage: 1
    };
    public completedData: string[] = [];
    public configs = new CommonConfig();

    public async autoCompleteGoogle(value: string) {
        this.formData.address = value;
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/autocomplete?searchtext=${value}`;
        const fetched = await AxiosPromise.get(google);
        let autoData: any[] = [];
        if (fetched.code === 200) {
            autoData = fetched.data.predictions ? fetched.data.predictions : [];
        }
        this.completedData = autoData.map((v: any) => v.description);
    }
    public debounceAsync<F extends Function>(func: F, wait: number): F {
        let timeoutID: number;
        if (!Number.isInteger(wait)) {
            wait = 300;
        }
        return <F><any>function (this: any, ...args: any[]) {
            clearTimeout(timeoutID);
            const context = this;
            timeoutID = window.setTimeout(async function () {
                await func.apply(context, args);
            }, wait);
        };
    }
    public debounce<F extends Function>(func: F, wait: number): F {
        let timeoutID: number;
        if (!Number.isInteger(wait)) {
            wait = 300;
        }
        return <F><any>function (this: any, ...args: any[]) {
            clearTimeout(timeoutID);
            const context = this;
            timeoutID = window.setTimeout(function () {
                func.apply(context, args);
            }, wait);
        };
    }
    public debounceAutoComplete = this.debounceAsync(this.autoCompleteGoogle, 300);
    public handleSearch(value: string) {
        this.debounceAutoComplete(value);
    }
    public validateEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    public changeBedRoom(val: number) {
        this.roomData.bedroom = val;
    }
    public changeWashRoom(val: number) {
        this.roomData.washroom = val;
    }
    public changeGarage(val: number) {
        this.roomData.garage = val;
    }
    public async handleSubmit() {
        if (!this.clientData.name) {
            this.$Notice.error({
                title: '信息不全',
                desc: `用户姓名不能为空`
            });
            return;
        }
        if (!this.clientData.email) {
            this.$Notice.error({
                title: '信息有误',
                desc: `用户邮箱不能为空`
            });
            return;
        }
        if (!this.validateEmail(this.clientData.email)) {
            this.$Notice.error({
                title: '信息有误',
                desc: `用户邮箱格式有误`
            });
            return;
        }
        // address
        if (!this.formData.address) {
            this.$Notice.error({
                title: '信息有误',
                desc: `房源地址不能为空`
            });
            return;
        }
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/places?searchtext=${this.formData.address}`;
        const fetched = await AxiosPromise.get(google);
        let geoLocation = null;
        if (fetched.code === 200) {
            if (!fetched.data.candidates || fetched.data.candidates.length === 0) {
                this.$Notice.error({
                    title: '房源地址有误',
                    desc: `没有查到符合输入的房源地址`
                });
                return;
            }
            geoLocation = fetched.data.candidates[0].geometry;
        } else {
            this.$Notice.error({
                title: '失败',
                desc: `网络问题， 请稍后重试`
            });
            return;
        }
        if (isNaN(this.roomData.bedroom) || this.roomData.bedroom < 0) {
            this.$Notice.error({
                title: '信息有误',
                desc: `卧室数量信息有误`
            });
            return;
        }
        if (this.roomData.bedroom > 99) {
            this.$Notice.error({
                title: '信息有误',
                desc: `卧室数量超出上限`
            });
            return;
        }
        if (isNaN(this.roomData.washroom) || this.roomData.washroom < 0) {
            this.$Notice.error({
                title: '信息有误',
                desc: `卫生间数量信息有误`
            });
            return;
        }
        if (this.roomData.washroom > 99) {
            this.$Notice.error({
                title: '信息有误',
                desc: `卫生间数量超出上限`
            });
            return;
        }
        if (isNaN(this.roomData.garage) || this.roomData.garage < 0) {
            this.$Notice.error({
                title: '信息有误',
                desc: `车库数量信息有误`
            });
            return;
        }
        if (this.roomData.garage > 99) {
            this.$Notice.error({
                title: '信息有误',
                desc: `车库数量超出上限`
            });
            return;
        }
        this.$store.commit('lpMobileSetClientInfo', {
            email: this.clientData.email,
            name: this.clientData.name,
            phoneSuffix: '+1',
            phone: '',
            salutations: '',
        });
        this.$store.commit('lpMobileSetPropertyInfo', {
            propertyType: this.formData.type,
            bedrooms: this.roomData.bedroom,
            bedroomsPlus: '',
            washrooms: this.roomData.washroom,
            garages: this.roomData.garage,
            picture: '',
        });
        this.$store.commit('lpMobileSetSubjectSearchText', this.formData.address);
        this.$store.commit('lpMobileSetGoogleFomattedLocation', geoLocation.location);
        this.$router.push('/hybrid/listing-presentation/compare');
    }
    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
    public created() {
        const activityId = this.$route.query.activityId;
        this.activityId = activityId;
        const entrustId = this.$route.query.entrustId;
        this.entrustId = entrustId;
        this.globalPudge.functions.setParam('activityId', activityId);
        this.globalPudge.functions.setParam('entrustId', entrustId);
    }
    public mounted() {
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeSetNavTitle, {
            'title_cn': '生成报告',
            'title_en': 'New Presentation',
        });
    }
}
